import { CheckboxTheme } from '../../types';

export const SWITCH_DEFAULT_THEME: CheckboxTheme = {
    colors: {
        default: 'grey.base',
        checked: 'primary.base',
    },
};
